/**
 * ****************************************************************************
 * @description     :   Route for chats app
 * @created at      :   2022/06/10
 * @created by      :   ANS873 – baonx@ans-asia.com
 * @package         :   Frontier Consulting
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */

/**
 * Import component of view
 */
const ra003600s = () => import('@/views/system/ra003600s');
/**
 * Defined Router
 */
export default [
    {
        path: '/system/ra003600s',
        name: 'ra003600s',
        component: ra003600s,
        meta: {
            title: '履歴照会'
        }
    }
];
